<div class="monitoring mt-32" [class.no-animation]="noAnimation">
  <div class="monitoring__header" #monitoringHeaderWrapper>
    <div class="wrapper__header" #monitoringHeaderFixed>
      <app-monitoring-filter [filter]="filter" [loading]="loading"></app-monitoring-filter>
      <div class="header__days mt-24">
        <div class="days__left-block"></div>
        <div class="days-block js-days-block">
          <div class="days-block__wrapper-block">
            <div class="days-block__wrapper" #wrapperHeaderDaysSlide
                 [class.days-block__wrapper-grs]="isGRS">
              <div class="day-block" *ngFor="let d of times">
                <div class="next-date-one">
                  {{ d.date | dateFormat: 'DD MMMM YYYY' }}
                </div>
                <div class="next-date-two">
                  {{ d.date | dateFormat: 'DD MMMM YYYY' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="days__right-block"></div>
      </div>
      <div class="header__items mt-8">
        <div class="header__item header__item-name font-weight-bold">
          ФИО
          <div class="item__name-expand-ctrl" (click)="onToggleAllBrigades()">
            <button type="button" class="ctrl" *ngIf="isAllBrigadesOpened" title="Свернуть все бригады">
              <app-icon [glyph]="'sort-up'" [size]="'20'"></app-icon>
            </button>
            <button type="button" class="ctrl" *ngIf="!isAllBrigadesOpened" title="Развернуть все бригады">
              <app-icon [glyph]="'sort-down'" [size]="'20'"></app-icon>
            </button>
          </div>
        </div>
        <div class="header__item header__item-work-day font-weight-bold">График</div>
        <div class="header__item header__item-left-nav">
          <button type="button"
                  class="item-time__nav item-time__nav-left"
                  [attr.disabled]="isClickPrevented"
                  (click)="onPrevSlide()">
            <app-icon [glyph]="'arrow-left'"
                      [size]="'12'"
                      [color]="'gray-dark'">
            </app-icon>
          </button>
        </div>
        <div class="header__item header__item-time" #headerItemTime>
          <div class="header-time-block__wrapper-block">
            <div class="header-time-block__wrapper"
                 [class.header-time-block__wrapper--grs]="isGRS"
                 #wrapperHeaderSlide>
              <div *ngFor="let intervalHeader of this.times"
                   class="header-time-block"
                   [attr.data-header-date]="intervalHeader.date">
                <div class="header-time-block__item"
                     *ngFor="let i of intervalHeader.times; let index = index" id="{{ 'time_' + intervalHeader.date + '_' + index }}">
                  {{ i }}
                </div>
                <app-current-time
                  [currentTime]="filter.currentTime"
                  *ngIf="filter.currentTime">
                </app-current-time>
              </div>
            </div>
          </div>
        </div>
        <div class="header__item header__item-right-nav">
          <button type="button"
                  class="item-time__nav item-time__nav-right"
                  [attr.disabled]="isClickPrevented"
                  (click)="onNextSlide()">
            <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
          </button>
        </div>
        <div class="header__item header-item__worked font-weight-bold">Отработано</div>
      </div>
    </div>
  </div>
  <div class="pos-r">
    <div class="monitoring__content" #monitoringContent>
      <!--fake block-->
      <div *ngIf="loading">
        <app-loader></app-loader>
      </div>
      <div class="content__brigade content__brigade--fake" style="visibility: hidden">
        <div class="brigade-workers pos-r">
          <div class="brigade-workers__wrapper">
            <div class="content-items">
              <div class="content-item content-item__name"></div>
              <div class="content-item content-item__work-day"></div>
              <div class="content-item content-item__time js-content-item__time timeline">
                <div class="content-time-block__wrapper js-content-time-block__wrapper"
                     [class.content-time-block__wrapper--grs]="isGRS"></div>
              </div>
              <div class="content-item content-item__worked"></div>
            </div>
          </div>
        </div>
      </div>
      <!--end fake block-->
      <div class="content__brigade" *ngFor="let brigade of brigadesFiltered">
        <div class="brigade-name">
          <div class="tickets-list__item">
            <div class="grid grid--gap-8 cur-pointer" (click)="onChangeBrigadeStateOpened(brigade, null)">
              <div class="grid__box grid__box--size-min" *ngIf="brigade.isOpened">
                <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min" *ngIf="!brigade.isOpened">
                <app-icon [glyph]="'arrow-right'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
              </div>
              <div class="grid__box grid__box--size-min">
                <a class="link link--dotted-blue-dark link--bold">{{ brigade.brigade_name }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="brigade-workers pos-r">
          <div class="padding-24" *ngIf="brigade.brigadeDataLoading">
            <app-loader></app-loader>
          </div>
          <div class="brigade-workers__wrapper" [hidden]="!brigade.isOpened">
            <div class="employers" [hidden]="brigade.brigadeDataLoading">
              <div class="content-items" *ngFor="let employee of brigade.employers" [attr.data-employee-id]="employee.u_id">
                <div class="content-item content-item__name">
                  <div class="pr-2">
                    <div class="text-ellipsis">
                      {{ employee.employee.full_name }}
                    </div>
                    <div class="grid grid--gap-8">
                      <div class="grid__box grid__box--size-min">
                        <app-user-popover [user]="employee"></app-user-popover>
                      </div>
                      <div class="grid__box grid__box--size-min">
                        <app-way-movement [status]="employee.worklog && employee.worklog.transport"></app-way-movement>
                      </div>
                      <div class="grid__box grid__box--size-min cur-help" *ngIf="employee.is_brigade_head" title="Бригадир">
                        <app-icon [glyph]="'admin'" [size]="'18'" [color]="'gray'" [class]="'icon--va-middle'"></app-icon>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content-item content-item__work-day">
                  <div class="grid grid--va-middle grid--gap-8" *ngIf="employee.currentWorkDay && employee.currentWorkDay.isWorked">
                    <div class="grid__box grid__box--size-min">
                      <div
                        *ngIf="!employee.currentWorkDay.isWorkedOtherSector"
                        class="cell-square {{ 'cell-square--' + Enums.cellSquare[employee.currentWorkDay.cellType.ct_id] }}"
                      ></div>
                      <div *ngIf="employee.currentWorkDay.isWorkedOtherSector" class="cell-square {{ 'cell-square--' + Enums.cellSquare[2] }}"></div>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <a
                        class="link"
                        target="_blank"
                        [routerLink]="[
                          '/',
                          WORK_SHIFTS_PATHS.work_shifts,
                          {
                            sector_id: employee.sector_id,
                            full_name: employee.employee.full_name,
                            int_begin: filter.calendar.linkDate
                          }
                        ]"
                      >
                        <span *ngIf="employee.currentWorkDay.isWorkedOtherSector"> Командировка </span>
                        <span *ngIf="!employee.currentWorkDay.isWorkedOtherSector">
                          <span *ngIf="employee.currentWorkDay.cellType && employee.currentWorkDay.cellType.ct_id === 1">
                            {{ employee.currentWorkDay.int_begin | dateFormat: 'HH:mm' }}
                            -
                            {{ employee.currentWorkDay.int_end | dateFormat: 'HH:mm' }}
                          </span>
                          <span *ngIf="employee.currentWorkDay.cellType && employee.currentWorkDay.cellType.ct_id !== 1">
                            {{ employee.currentWorkDay.cellType.ct_name }}
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="content-item content-item__time js-content-item__time timeline">
                  <div class="content-time-block__wrapper js-content-time-block__wrapper"
                       [class.content-time-block__wrapper--grs]="isGRS">
                    <ng-container *ngIf="!brigade.brigadeDataLoading">
                      <div
                        class="time-block"
                        *ngFor="let day of employee.groupByDays.days; trackBy: trackByFn"
                        [attr.data-content-date]="day.workday"
                        (click)="onOpenChangeStatusDialog(employee, brigade)"
                      >
                        <div *ngFor="let k of day.times; trackBy: trackByIndex"
                             class="time-block__item"
                             [attr.data-content-date]="day.workday"
                             [attr.data-content-time]="k"
                             id="{{'employee_' + employee.u_id + '_' + day.workday + '_' + k }}">
                        </div>
                        <app-employee-work-interval
                          [workInterval]="day.workInterval"
                          [workday]="day.workday"
                          [employeeId]="employee.u_id">
                        </app-employee-work-interval>
                        <app-employee-work-statuses
                          [workStatuses]="day.workStatuses"
                          [workday]="day.workday"
                          [employeeId]="employee.u_id">
                        </app-employee-work-statuses>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div *ngIf="employee.groupByDays"
                     class="content-item content-item__worked">
                  <app-employee-worked [currentDate]="currentDate"
                                       [worked]="employee.groupByDays.worked">
                  </app-employee-worked>
                </div>
              </div>
            </div>
            <div class="brigade-tickets" *ngIf="!brigade.brigadeDataLoading">
              <div class="brigade-tickets-name">
                <div class="tickets-list__item">
                  <div class="grid grid--gap-8 cur-pointer" (click)="onChangeBrigadeTicketsStateOpened(brigade)">
                    <div class="grid__box grid__box--size-min" *ngIf="brigade.isBrigadeTicketsOpened">
                      <app-icon [glyph]="'arrow-down'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                    </div>
                    <div class="grid__box grid__box--size-min" *ngIf="!brigade.isBrigadeTicketsOpened">
                      <app-icon [glyph]="'arrow-right'" [size]="'10'" [color]="'gray-dark'" [class]="'icon--va-middle'"></app-icon>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      <a class="link link--dotted-blue-dark">{{ isGRS ? 'Выезды' : 'Заявки' }}</a>
                    </div>
                    <div class="grid__box grid__box--size-min">
                      (
                      <span class="color-gray-dark">{{ (brigade.statusesData && brigade.statusesData.finished) || 0 }}</span>
                      <span class="color-blue-dark"> / </span>
                      <span class="color-red-dark">{{ (brigade.statusesData && brigade.statusesData.expired) || 0 }}</span>
                      <span class="color-blue-dark"> / </span>
                      <span class="color-blue-dark">{{ (brigade.statusesData && brigade.statusesData.all) || 0 }}</span>
                      )
                    </div>
                  </div>
                </div>
              </div>
              <div class="tickets" [hidden]="!brigade.isBrigadeTicketsOpened">
                <ng-container *ngIf="brigade.tickets && brigade.tickets.length">
                  <div class="content-items" *ngFor="let ticket of brigade.tickets">
                    <div class="content-item content-item__name">
                      <div class="pr-2">
                        <div class="grid grid--va-middle grid--gap-4">
                          <div class="grid__box grid__box--size-2">
                            <app-tickets-types [ticket]="ticket"></app-tickets-types>
                          </div>

                          <div class="grid__box grid__box--size-5">
                            <a target="_blank"
                               [routerLink]="['/', TICKETS_PATHS.ticketLink, isGRS ? ticket.ticket_id : ticket.id]"
                               title="{{ isGRS ? ticket.departure_status.name : ticket.ticket_status.name }}"
                               class="link link--{{ Enums.ticketHighlightStatuses[isGRS ? ticket.departure_status.id : ticket.ticket_status.id] }}">
                              {{ ticket.hd_ticket_number }}</a>
                          </div>

                          <div class="grid__box grid__box--size-5"
                               *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 3) || ticket.ticket_type.id === 4">
                            <div class="text-ellipsis cur-help" title="{{ ticket.ticket_subtype }}">
                              {{ ticket.ticket_subtype }}
                            </div>
                          </div>
                        </div>
                        <div class="grid grid--va-middle grid--gap-4">
                          <div class="grid__box grid__box--size-2"></div>
                          <div class="grid__box grid__box--size-8">
                            <span class="link link--{{ Enums.ticketHighlightStatuses[isGRS ? ticket.departure_status.id : ticket.ticket_status.id] }} link--no-underline link--not-hovered">
                              {{ isGRS ? ticket.departure_status.name : ticket.ticket_status.name }}</span>
                          </div>
                          <div
                            class="grid__box grid__box--size-2 grid__box--justify-content-flex-end ta-right"
                            *ngIf="(ticket.ticket_type && ticket.ticket_type.id === 1) || ticket.ticket_type.id === 2 || ticket.ticket_type.id === 3"
                          >
                            <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                            <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="content-item content-item__work-day">
                      <div class="grid grid--gap-4 grid--va-middle">
                        <div class="grid__box grid__box--size-min">
                          {{ ticket.hd_schedule_intbegin | dateFormat: 'HH:mm' }}
                        </div>
                        <div class="grid__box grid__box--size-min">
                          <div class="mdash"></div>
                        </div>
                        <div class="grid__box grid__box--size-min">
                          {{ ticket.hd_schedule_intend | dateFormat: 'HH:mm' }}
                        </div>
                      </div>
                    </div>
                    <div class="content-item content-item__time js-content-item__time timeline">
                      <div *ngIf="ticket.groupByDays"
                           class="content-time-block__wrapper js-content-time-block__wrapper"
                           [class.content-time-block__wrapper--grs]="isGRS"
                           [style.left.px]="slidePosition">
                        <div *ngFor="let day of ticket.groupByDays.days; trackBy: trackByFn"
                             class="time-block"
                             [attr.data-content-date]="day.workday">
                          <div *ngFor="let k of day.times"
                               class="time-block__item"
                               [attr.data-content-date]="day.workday"
                               [attr.data-content-time]="k"
                               id="{{ 'ticket_' + (isGRS ? ticket.ticket_id : ticket.id) + '_' + day.workday + '_' + k }}">
                          </div>
                          <app-monitoring-work-interval [workInterval]="day.workInterval"
                                                        [ticketId]="isGRS ? ticket.ticket_id : ticket.id"
                                                        [workday]="day.workday"></app-monitoring-work-interval>
                          <app-monitoring-work-statuses [workStatuses]="day.workStatuses"
                                                        [ticketId]="isGRS ? ticket.ticket_id : ticket.id"
                                                        [workday]="day.workday">
                          </app-monitoring-work-statuses>
                        </div>
                      </div>
                    </div>
                    <div class="content-item content-item__worked" *ngIf="ticket.groupByDays">
                      <app-monitoring-work-worked [worked]="ticket.groupByDays.worked"></app-monitoring-work-worked>
                    </div>
                  </div>
                </ng-container>
                <div class="color-gray text-italic" *ngIf="brigade.tickets && !brigade.tickets.length">
                  <div class="content-items">Нет назначенных заявок на бригаду</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
